module.exports = __webpack_public_path__ + "img/banner.b45c0ba5.svg";